<script>
import { layoutMethods } from "@/state/helpers";
// import { required } from "vuelidate/lib/validators";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { reportsMethods, reportsComputed, exportMethods,eventListMethods,eventsComputed,eloadRewardsComputed,eloadRewardsMethods } from "@/state/helpers"
// import { stat } from "fs";
// import Swal from 'sweetalert2';
import Multiselect from "vue-multiselect";
// import shortid from "shortid";


/**
 * E-Load list component
 */
export default {
  page: {
    title: "E-Load Rewards Preview"
  },
  data() {
    return {
      eloadRewardsForm: {
        receiver: [],
        amount:null,
        type:null,
        name:null,
        event_date:null,
        note:null,
        file:null,
        s3_url:null,
        saveType:null
      },
      typeOptions:[
        {"value":"c","name":"Compensation for irate cx"},
        {"value":"r","name":"Reimbursement"},
        {"value":"p","name":"Promo"},
        {"value":"g","name":"Giveaway"},
        {"value":"s","name":"Sales"},
      ],
      config: {
        enableTime: true,
        dateFormat: "m/d/Y h:i K",
        maxDate: new Date()
      },
      addWinnerTblFields: [
        {
          key: 'business',
          label:'Store Name',
          sortable: false
        },
        {
          key: 'name',
          label:'Customer Name',
          sortable: false
        },
        {
          key: 'mobile_number',
          sortable: false
        },
        {
          key: 'email_address',
          sortable: false
        },
        {
          key: 'amount',
          sortable: false
        },
      ],
      TotalWinnerAmount: 0,
      displayWinnerPagination:{rows:10,page:1},
      displayWinnerTbl:[]
    };
  },
  components: {
    flatPickr,
    Multiselect,
  },
  computed: {
    ...reportsComputed,
    ...eventsComputed,
    ...eloadRewardsComputed,
  },
  mounted() {
    this.getEventInfo(this.$route.params.id);
    this.changeTitle({title: 'Eload Reward Preview'});
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: 'Peddlr', to: { name: 'Home'} },
        { text: 'Report', to: { name: 'Report'}},
        { text: 'Eload Rewards', to: { name: 'Eload Rewards'}},
        { text: 'Eload Add Rewards', to: { name: 'Eload Add Rewards'}},
      ]
    });
  },
  methods: {
    ...layoutMethods,
    ...reportsMethods,
    ...exportMethods,
    ...eventListMethods,
    ...eloadRewardsMethods,
    async getEventInfo(id){
      await this.actionEloadReward({
          action: "eload-rewards-info",
          body: {"event_id":id}
      })
      .then((res) => {
        console.log(res);
        this.eloadRewardsForm = {...res.message}
        this.eloadRewardsForm.event_date = new Date(res.message["event_date"]);
        this.winnerTblPaginator();
        this.recompute();
      }).catch((e)=>{
        console.log("error while getting reward info",e);
      });
    },
    winnerTblPaginator(){
      this.displayWinnerTbl = [];
      for(var i = ((this.displayWinnerPagination.page - 1)*this.displayWinnerPagination.rows); i < this.eloadRewardsForm.receiver.length; i++){
        if(this.displayWinnerTbl.length < this.displayWinnerPagination.rows){
          this.displayWinnerTbl.push(this.eloadRewardsForm.receiver[i]);
        }
      }
    },
    recompute(){
      this.TotalWinnerAmount = 0
      for(let x of this.eloadRewardsForm.receiver){
        this.TotalWinnerAmount += parseInt(x["amount"])
      }
    },
    isEmpty(value){
        return (
        // null or undefined
        (typeof value == "undefined") || 
        (value == undefined) ||
        (value == null) ||
        (value === "") ||
        // has length and it's zero
        (Object.prototype.hasOwnProperty.call(value,'length') && value.length === 0) ||
        // is an Object and has no keys
        (value.constructor === Object && Object.keys(value).length === 0)
        )
    },
  }
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <h5 class="card-title">
                    ELoad Reward Preview
                  </h5>
                </div>
              </div>
              <!-- end col -->
              <!-- Search and button -->
              <form class="px-4" @submit.prevent="handleSubmit()">
                <div class="row mb-2 px-3">
                  <div class="mb-3 col-md-12">
                    <label class="form-label small fw-bold">Event Name<span style="color: red">*</span></label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="eloadRewardsForm.name"
                      placeholder="Type campaign Name"
                      disabled
                    />
                  </div><!--event name-->
                  <div class="mb-3 col-sm-6">
                    <label class="form-label">Event Date<span style="color: red">*</span></label>
                    <flat-pickr
                      v-model="eloadRewardsForm.event_date"
                      :config="config"
                      placeholder="Select event date & time"
                      name="eventdate"
                      class="form-control"
                      disabled
                    ></flat-pickr>
                  </div><!--event date-->
                  <div class="col-md-6 mb-3">
                    <label class="form-label small fw-bold">Type<span style="color: red">*</span></label>
                    <multiselect 
                      v-model="eloadRewardsForm.type" 
                      deselect-label="Can't remove this value" 
                      track-by="value" label="name" 
                      placeholder="Select type here..." 
                      :options="typeOptions" 
                      :searchable="false" 
                      :allow-empty="false"
                      disabled>
                      <template slot="singleLabel" slot-scope="{ option }">
                        <span class="text-capitalize">{{ option.name }}</span>
                      </template>
                    </multiselect>
                  </div><!--event type-->
                  <div class="mb-3 col-sm-12">
                    <label class="form-label">Supporting Document <span style="color: red">*</span></label><br>
                    <a :href="eloadRewardsForm.documentSignUrl" target="_blank" v-if="eloadRewardsForm.documentSignUrl != null">
                      <i class="uil-file-alt"></i> Link here
                    </a> 
                  </div><!--supporting document-->
                  <div class="col-md-12">
                    <template>
                      <div>
                        <label class="form-label">Note</label>
                        <b-form-textarea
                          id="textarea"
                          v-model="eloadRewardsForm.note"
                          placeholder="Enter note here..."
                          rows="3"
                          max-rows="6" disabled
                        ></b-form-textarea>
                      </div>
                    </template>
                  </div><!--Event Note-->
                  <div class="col-md-12 mt-4">
                    <span class="mt-4">Total Winner: {{ eloadRewardsForm.receiver.length }}<br>Total Amount: PHP {{ TotalWinnerAmount | toCurrency}}</span>
                  </div>
                  <div class="col-sm-12">
                    <!-- table responsive -->
                    <div class="table-responsive" v-if="eloadRewardsForm.receiver.length > 0">
                      <div class="table align-middle table-nowrap">
                        <!-- eloadRewardsForm.receiver -->
                        <b-table
                          :items="displayWinnerTbl"
                          :fields="addWinnerTblFields"
                          responsive="sm"
                        >
                          <template #cell(business)="data">
                            <router-link :to="{ name: 'Business Detail', params: { id: data.item.business_id }}">
                              <span class="text-capitalize">{{(data.item.business == null ? "-":data.item.business) | truncator(20,'...')}}</span>
                            </router-link>
                          </template>
                          <template #cell(name)="data">
                            <router-link :to="{ name: 'Subscriber Detail', params: { id: data.item.user_id }}" class="customer-name">
                              <span class="text-capitalize">{{!isEmpty(data.item.name)?data.item.name:(!isEmpty(data.item.cognito_sub)?data.item.cognito_sub:'-') | truncator(20,'...')}}</span>
                            </router-link>
                          </template>
                          <template #cell(email_address)="data">
                            <span>{{(data.item.email == null ? "-":data.item.email)}}</span>
                          </template>
                          <template #cell(mobile_number)="data">
                            <span>{{data.item.mobile_number}}</span>
                          </template>
                          <template #cell(amount)="data">
                            PHP {{ data.item.amount | toCurrency }}
                          </template>
                        </b-table>
                      </div>
                    </div>
                    <div class="row g-0 text-center" v-if="eloadRewardsForm.receiver.length == 0 && false">
                      <span>No data to display.</span>
                    </div>
                    <div class="row g-0 text-center text-sm-start">
                      <!-- end col -->
                      <div class="col-sm-12"  v-if="eloadRewardsForm.receiver.length != 0 && eloadRewardsForm.receiver.length > 10">
                        <div class="row">
                          <div class="col">
                            <div
                              class="
                                dataTables_paginate
                                paging_simple_numbers
                                float-end
                              "
                            >
                              <!-- pagination -->
                              <b-pagination  v-if="eloadRewardsForm.receiver.length != 0 && eloadRewardsForm.receiver.length > 10"
                                class="pagination-rounded"
                                v-model="displayWinnerPagination.page"
                                :total-rows="eloadRewardsForm.receiver.length"
                                :per-page="displayWinnerPagination.rows"
                                @input="winnerTblPaginator"
                              ></b-pagination>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- end col -->
                    </div>
                  </div><!--end of col-12-->
                </div>
                <div class="row mt-3 mb-2 px-3">
                  <div class="col-md-6 mt-3 p-0">
                    
                  </div>
                  <div class="col-md-6 mt-3 ta-right p-0">
                    <router-link :to="{ name: 'Eload Rewards', params: {} }" class="tc-white">
                      <b-button variant="light" class="w-sm ml-2" type="button" >Close</b-button>
                    </router-link>
                  </div>
                </div>
              </form>
            </div>
            <!-- end col -->
            <!-- end row -->
            
          </div>
          <!-- end card body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->

  </div>
</template>
<style>
.custom-checkbox-method label {margin-left: 10px;}
.custom-checkbox-method input {margin-left: 15px;}
.required-input {color:red;}
.calendar-icon {display: block;font-size: 20px;padding: 8px;background-color: grey;}
.custom__tag{
    padding: 1px 5px;
    background: #E73092;
    color: #FFF;
    border-radius: 10px;
    margin-right: 5px;
}
.custom__remove, .c-pointer{
  cursor: pointer;
}
.fs-12{
  font-size: 12px;
}
.ml-2{
  margin-left: 10px;
}
</style>